import type {CSSProperties, ReactElement, ReactNode} from "react";
import {Col, css, Row, Text} from "../Box/Box";
import {subThemes} from "../../css/themes/themes.css";
import cx from "../../utils/cx";

export const DSFieldSetClassName = css({
  display: "flex",
  flexDir: "column",
  sp: "32px",
  pa: "16px",
  borderWidth: 0,
  position: "relative",
});

type Props = {
  title: string | ReactElement;
  titleAction?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const DSFormShell = ({children, title, titleAction, className, style}: Props) => (
  <Col
    bg
    divideX
    color="secondary"
    rounded={4}
    position="relative"
    className={cx(subThemes.gray25Tile, className)}
    style={style}
    data-cdx-context={typeof title === "string" ? title : null}
  >
    {titleAction ? (
      <Row sp="12px" align="center" pa="16px">
        <Text type="label16" as="h3" color="primary" mr="auto">
          {title}
        </Text>
        {titleAction}
      </Row>
    ) : (
      <Text type="label16" as="h3" pa="16px" color="primary">
        {title}
      </Text>
    )}
    {children}
  </Col>
);

export const DSFieldSet = ({children, ...rest}: Props) => (
  <DSFormShell {...rest}>
    <fieldset className={DSFieldSetClassName}>{children}</fieldset>
  </DSFormShell>
);
